// Schritt 04 — Konstruktion (Lücke aus dem Planer-Konzept).
// Auswahl Befestigungssystem / Schiene / Verlegung / Klemmen. Persistiert die
// Auswahl in der Revision (session-state hier; Werte fließen in die BOM/Kalkulation).
import { useState } from "react";

const sectionCard: React.CSSProperties = {
  background: "var(--color-surface,#fff)",
  border: "1px solid var(--color-border,#e2e8f0)",
  borderRadius: 12,
  boxShadow: "0 1px 3px rgba(15,23,42,.07)",
  overflow: "hidden",
};
const header: React.CSSProperties = { display: "flex", alignItems: "center", gap: 8, padding: "12px 14px", borderBottom: "1px solid #eef1f5" };
const navySquare = <span style={{ width: 11, height: 11, background: "#1e3a5f", borderRadius: 2 }} />;
const input: React.CSSProperties = { height: 30, border: "1px solid #cbd5e1", borderRadius: 6, padding: "0 10px", fontSize: 13, width: "100%", boxSizing: "border-box" };
const label: React.CSSProperties = { fontSize: 12.5, color: "#475569", display: "block", marginBottom: 4 };

const SYSTEMS = ["SL Rack", "K2 Systems", "Schletter", "Novotegra"];
const VERLEGUNG = ["horizontal", "vertikal"] as const;

export function KonstruktionStep() {
  const [s, setS] = useState({
    system: "SL Rack",
    rail: "RAIL 60 – 4750 mm",
    clampEnd: "Endklemme mit Erdung",
    clampMid: "Mittelklemme Vario mit Erdung",
    verlegung: "horizontal" as (typeof VERLEGUNG)[number],
    railsPerModule: 3,
    screw: "Tellerkopf 6×80 mm TX 30",
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
        <div style={sectionCard}>
          <div style={header}>{navySquare}<h3 style={{ fontSize: 13.5, fontWeight: 700, margin: 0 }}>Befestigungssystem</h3></div>
          <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 12 }}>
            <div>
              <label style={label}>Hersteller / System</label>
              <select style={input} value={s.system} onChange={(e) => setS({ ...s, system: e.target.value })}>
                {SYSTEMS.map((x) => <option key={x}>{x}</option>)}
              </select>
            </div>
            <div>
              <label style={label}>Modulschiene</label>
              <input style={input} value={s.rail} onChange={(e) => setS({ ...s, rail: e.target.value })} />
            </div>
            <div>
              <label style={label}>Dachhaken-Schraube</label>
              <input style={input} value={s.screw} onChange={(e) => setS({ ...s, screw: e.target.value })} />
            </div>
            <div>
              <label style={label}>Verlegung</label>
              <div style={{ display: "flex", gap: 8 }}>
                {VERLEGUNG.map((v) => (
                  <button
                    key={v}
                    type="button"
                    onClick={() => setS({ ...s, verlegung: v })}
                    style={{
                      flex: 1,
                      height: 32,
                      borderRadius: 6,
                      border: `1px solid ${s.verlegung === v ? "#2563eb" : "#e2e8f0"}`,
                      background: s.verlegung === v ? "#eff6ff" : "#fff",
                      color: s.verlegung === v ? "#1d4ed8" : "#64748b",
                      fontSize: 13,
                      cursor: "pointer",
                      textTransform: "capitalize",
                    }}
                  >
                    {v}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <label style={label}>Montageschienen pro Modul</label>
              <input type="number" min={1} max={4} style={input} value={s.railsPerModule} onChange={(e) => setS({ ...s, railsPerModule: Number(e.target.value) })} />
            </div>
          </div>
        </div>

        <div style={sectionCard}>
          <div style={header}>{navySquare}<h3 style={{ fontSize: 13.5, fontWeight: 700, margin: 0 }}>Klemmen</h3></div>
          <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 12 }}>
            <div>
              <label style={label}>Endklemme</label>
              <input style={input} value={s.clampEnd} onChange={(e) => setS({ ...s, clampEnd: e.target.value })} />
            </div>
            <div>
              <label style={label}>Mittelklemme</label>
              <input style={input} value={s.clampMid} onChange={(e) => setS({ ...s, clampMid: e.target.value })} />
            </div>
            <div style={{ marginTop: 4, padding: 12, background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, fontSize: 12.5, color: "#15803d" }}>
              ✓ Modulrahmen 30 mm — Klemmbereich passt für End- und Mittelklemme.
            </div>
            <div style={{ padding: 12, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, color: "#64748b", lineHeight: 1.5 }}>
              Verlegung {s.verlegung} · {s.railsPerModule} Schienen pro Modul · {s.system}.
              Die Materialmengen (Schienen, Klemmen, Schrauben, Endkappen) werden in Schritt 10
              (Ausgabe) aus diesen Vorgaben über die Stückliste generiert.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
